<div id="number-scroller" class="border-primary" [class.input-focused]="isInputFocused" [ngClass]="getBorderWarnClass()">
  <div id="number-scroller-body">
    <button mat-icon-button class="color-primary mic-icon-button-large" (click)="stepMinus()" (focus)="onFocus()" (blur)="onBlur()">
      <mat-icon class="color-primary">remove</mat-icon>
    </button>
    <div id="year-display">
      <input matInput type="number"
             inputmode="numeric"
             min="{{ min }}" max="{{ max }}"
             nxNoScroll
             cdkFocusInitial
             class="caret-primary color-primary"
             (change)="valueChange()"
             [formControl]="valueCtrl"
             [ngClass]="getInputWarnClass()"/>
    </div>
    <button mat-icon-button class="color-primary mic-icon-button-large" (click)="stepPlus()" (focus)="onFocus()" (blur)="onBlur()">
      <mat-icon class="color-primary">add_2</mat-icon>
    </button>
  </div>
  <span *ngIf="notMultipleOfStep" id="number-scroller-error" class="color-warn">{{ notMultipleOfStep | translate }} {{step}}</span>
</div>

